export const isProd = process.env.NEXT_DEV_ENV === 'production'
export const isLocal = process.env.NEXT_DEV_ENV === 'development'

export const showLogger = isLocal
  ? true
  : process.env.NEXT_PUBLIC_SHOW_LOGGER === 'true' ?? false // if you want to force show logger in production
